import { Link } from "react-router-dom";
import { useGetQuizesQuery } from "../../../features/Quiz/quizApi";
import QuizItem from "./QuizItem";
import routes from "../../../config/routeConfig";

export default function Quiz() {
  const { data: quizes, isError, isLoading } = useGetQuizesQuery();

  return (
    <div className="px-3 py-20 bg-opacity-10">
      <div className="w-full flex">
        <Link to={routes.admin.addQuiz} className="ml-auto">
          <button className="btn">Add Quiz</button>
        </Link>
      </div>
      <div className="overflow-x-auto mt-4">
        <table className="divide-y-1 text-base divide-gray-600 w-full">
          <thead>
            <tr>
              <th className="table-th">Question</th>
              <th className="table-th">Video</th>
              <th className="table-th justify-center">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-600/50">
            {isLoading && (
              <tr>
                <td className="text-center" colSpan="100%">
                  Loading quizes...
                </td>
              </tr>
            )}
            {isError && (
              <tr>
                <td className="text-center" colSpan="100%">
                  Failed to fetch quiz!
                </td>
              </tr>
            )}
            {!isLoading && quizes.length === 0 && (
              <tr>
                <td className="text-center" colSpan="100%">
                  No quiz found!
                </td>
              </tr>
            )}

            {quizes?.map((quiz) => (
              <QuizItem quiz={quiz} key={quiz.id} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
